import { defineMessages } from "react-intl";

export default defineMessages({

  effective_date: {
    id: "admin.list.credit_certificate.effective_date",
    defaultMessage: "Effective date"
  },
  active: {
    id: "admin.form.credit_certificate.active",
    defaultMessage: "Active"
  },
  certificate_type: {
    id: "admin.form.credit_certificate.certificate_type",
    defaultMessage: "Certificate type"
  },
  certificate_id: {
    id: "admin.form.credit_certificate.certificate_id",
    defaultMessage: "Certificate ID"
  },
  item: {
    id: "admin.form.credit_certificate.item",
    defaultMessage: "Item"
  },
  authorisation_code: {
    id: "admin.form.credit_certificate.authorisation_code",
    defaultMessage: "Authorisation code"
  },
  subsidiary: {
    id: "admin.form.credit_certificate.subsidiary",
    defaultMessage: "Subsidiary"
  },
  location: {
    id: "admin.form.credit_certificate.location",
    defaultMessage: "Location"
  },
  currency: {
    id: "admin.form.credit_certificate.currency",
    defaultMessage: "Currency"
  },
  customer: {
    id: "admin.form.credit_certificate.customer",
    defaultMessage: "Customer"
  },
  available_from: {
    id: "admin.form.credit_certificate.available_from",
    defaultMessage: "Available from"
  },
  available_to: {
    id: "admin.form.credit_certificate.available_to",
    defaultMessage: "Available to"
  },
  amount: {
    id: "admin.form.credit_certificate.amount",
    defaultMessage: "Amount"
  },
  reason_code: {
    id: "admin.form.credit_certificate.reason_code",
    defaultMessage: "Reason code"
  },
  comment: {
    id: "admin.form.credit_certificate.comment",
    defaultMessage: "Comment"
  },

  from_transaction: {
    id: "admin.summary.credit_certificate.from_transaction",
    defaultMessage: "From transaction"
  },
  created_datetime: {
    id: "admin.summary.credit_certificate.created_datetime",
    defaultMessage: "Created"
  },

  available: {
    id: "admin.summary.credit_certificate.available",
    defaultMessage: "Available"
  },
  purchase_amount: {
    id: "admin.summary.credit_certificate.purchase_amount",
    defaultMessage: "Purchase amount"
  },

  /** SECTIONS */

  general: {
    id: "admin.section.credit_certificate.general",
    defaultMessage: "General"
  },
  created: {
    id: "admin.section.credit_certificate.created",
    defaultMessage: "Created"
  },
  used: {
    id: "admin.section.credit_certificate.used",
    defaultMessage: "Used"
  },

  /** BREADCRUMBS */

  home: {
    id: "admin.breadcrumbs.credit_certificate.home",
    defaultMessage: "Home"
  },
  concession: {
    id: "admin.breadcrumbs.credit_certificate.concession",
    defaultMessage: "Concession"
  },
  certificate: {
    id: "admin.breadcrumbs.credit_certificate.certificates",
    defaultMessage: "Certificate"
  },
  new_certificate: {
    id: "admin.breadcrumbs.credit_certificate.new_certificate",
    defaultMessage: "New certificate"
  },


  saved_certificate: {
    id: "admin.form.credit_certificate.saved_certificate",
    defaultMessage: "Credit certificate successfully saved"
  },

  required_certificate_id: {
    id: "admin.validation.credit_certificate.required_certificate_id",
    defaultMessage: "Certificate ID is required"
  },
  required_certificate_type: {
    id: "admin.validation.credit_certificate.required_certificate_type",
    defaultMessage: "Certificate type is required"
  },
  required_location: {
    id: "admin.validation.credit_certificate.required_location",
    defaultMessage: "Location is required"
  },
  required_available_from: {
    id: "admin.validation.credit_certificate.required_available_from",
    defaultMessage: "Available from is required"
  },
  required_available_to: {
    id: "admin.validation.credit_certificate.required_available_to",
    defaultMessage: "Available to is required"
  },
  required_amount: {
    id: "admin.validation.credit_certificate.required_amount",
    defaultMessage: "Amount is required"
  },
  required_authorisation_code: {
    id: "admin.validation.credit_certificate.required_authorisation_code",
    defaultMessage: "Authorisation code is required"
  },
});
